import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { AddBorrowerComponent } from '../add-borrower/add-borrower.component';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { QuestionnaireService } from '../services/questionnaire.service';
import { AnonymousSubscription } from 'rxjs/Subscription';
import { CheckBorrower_Request } from '../models/CheckBorrower_Request.model';
import { Draft } from '../services/draft.service';
import { MessagesError } from '../classes/messages-error-type';
import { AddBorrowersState } from '../enums/add-borrowers-state';
import { TranslateService } from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
	selector: 'app-borrowers-array',
	templateUrl: './borrowers-array.component.html',
	styleUrls: ['./borrowers-array.component.scss']
})
export class BorrowersArrayComponent implements OnInit {
	@Input() public borrowersArray: FormArray;
	@Input() public displayErrors: boolean;
	@Input() public qID: any;
	@Output() offError: EventEmitter<number> = new EventEmitter<number>();
	@Input() public childrenNumber: number[];
	@Input() public maritalStatus: string[];
	@Input() public status: string;
	@Input() public showRemove: boolean = false;
	@Input() public msgArr: Map<number, any>;
	@Input() public ifShowMessages: Array<MessagesError>;
	@Input() public customerIdNumberFormControl: FormControl;
	@Input() public attAriaLabel: any;
	isloading: Boolean = false;
	errorMessageOnComponent = [];
	isDisplayed = false;
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	@Output() errorMsg: EventEmitter<any> = new EventEmitter<any>();
	@Output() failedAddBorrowersCause: EventEmitter<AddBorrowersState> = new EventEmitter<AddBorrowersState>();
	maxBorrowerCount = 5;
	static isDisabled: boolean;

	constructor(
		private questionnaireService: QuestionnaireService,
		private draft: Draft,
		private translate: TranslateService,
	) { }

	ngOnInit() {
	}

	removeError() {
		this.offError.emit()
	}
	checkBorrowers(): AddBorrowersState {
		const borrowerIdNumber: string = this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerIdNumber;
		if (borrowerIdNumber === this.customerIdNumberFormControl.value) {
			return AddBorrowersState.EqualToCustomer;
		} else {
			for (let i = 0; i < this.borrowersArray.controls.length - 1; i++) {
				if (this.borrowersArray.controls[i].value.borrowerIdNumber == this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerIdNumber) {
					return AddBorrowersState.ExistInBorrowers;
				}
			}
			return AddBorrowersState.Valid
		}
	}

	addAndCheckBorrower() {
		if (this.borrowersArray.valid) {
			const addBorrowersState: AddBorrowersState = this.checkBorrowers();
			if (addBorrowersState === AddBorrowersState.Valid) {
				this.isloading = true;
				if (this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerBirthDate) {
					let paramsCheckBorrower: CheckBorrower_Request = {
						CustomerId: this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerIdNumber,
						DateOfBirth: this.questionnaireService.customFormatNgbDateStructToString(this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerBirthDate),
						PrefixPhone: (this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerPhoneNumber.substring(0, 3)) ? this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerPhoneNumber.substring(0, 3) : "",
						PhoneNumber: (this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerPhoneNumber.substring(3, 10)) ? this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerPhoneNumber.substring(3, 10) : "",
						Email: this.borrowersArray.controls[this.borrowersArray.length - 1].value.borrowerEmail,
					}
					this.draft.checkBorrower$(paramsCheckBorrower).subscribe(
						// this.checkBorrower$(null).subscribe(
						res => {
							this.isloading = false;
							this.draft._checkBorrowerStatus.next(res);
							this.addBorrower();
							this.draft.indexCheckBorrower = this.borrowersArray.length - 1;
						},
						err => {
							this.draft.indexCheckBorrower = this.borrowersArray.length - 1;
							this.draft._checkBorrowerStatus.next(err);
							this.isloading = false;
						}
					);
				}
			} else {
				this.failedAddBorrowersCause.emit(addBorrowersState);
			}
			this.isloading = false;
			// this.isDisplayed = false;
		}
		else {
			// this.isDisplayed = true;
			// this.errorMessageOnComponent = [{ text: this.translate.instant('BORROWERS_DETAILS.ERROR.ADD_ERROR') }];
			this.errorMsg.emit();

		}
	}

	addBorrower() {
		this.displayErrors = this.borrowersArray.invalid;
		if (this.borrowersArray.valid) {
			let newBorrowerId = this.borrowersArray.value.length + 1;


			this.borrowersArray.push(AddBorrowerComponent.buildBorrower({
				borrowerId: newBorrowerId.toString()
			}));
			this.onAddFormGroup.emit();
			this.displayErrors = this.borrowersArray.valid;
		}
	}

	simulateClick(event) {
		if (event.keyCode === 13) {
			event.currentTarget.click();
		}
	}

	static builBorrowers(value: any, kirva?: any, qID?: any) {
		let arr: FormGroup[] = [];
		if (value && value.length > 0) {
			if (kirva && kirva != 'נשוי/ה' && value[0].fields[4].answerValue == "בן/ בת זוג") {
				return new FormArray([]);
			}
			else if (kirva && kirva == 'נשוי/ה' && value[0].fields[4].answerValue == "בן/ בת זוג" && qID != "all" && qID == "7") {
				value[0].fields[4].answerValue = "בן/ בת זוג"
				return new FormArray([
					new FormGroup({
						borrowerFullName: new FormControl(value[0].fields[0].answerValue = ""),
						borrowerPhoneNumber: new FormControl(value[0].fields[1].answerValue = ""),
						borrowerBirthDate: new FormControl(value[0].fields[2].answerValue = ""),
						borrowerIdNumber: new FormControl(value[0].fields[3].answerValue = ""),
						borrowerProximity: new FormControl({ value: value[0].fields[4].answerValue = "בן/ בת זוג", disabled: true }),
						borrowerId: new FormControl(value[0].borrowerId || ""),
						borrowerEmail: new FormControl(value[0].fields[5].answerValue || "")
					})]);

			}
			else {
				value.forEach(element => {
					let borrowerBirthDate;
					// const dateParts = element.fields[2].answerValue.trim().split('/');
					// if (dateParts) {
					// 	borrowerBirthDate = { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
					// }
					if (element.fields[4].answerValue) {
						arr.push(new FormGroup({
							borrowerFullName: new FormControl(element.fields[0].answerValue || ""),
							borrowerPhoneNumber: new FormControl(element.fields[1].answerValue || ""),
							borrowerBirthDate: new FormControl(borrowerBirthDate || ""),
							borrowerIdNumber: new FormControl(element.fields[3].answerValue || ""),
							borrowerProximity: new FormControl({ value: element.fields[4].answerValue || "", disabled: element.fields[4].answerValue === "בן/ בת זוג" ? true : false }),
							borrowerId: new FormControl(element.borrowerId || ""),
							borrowerEmail: new FormControl(value[0].borrowerEmail || "")
						}))
					}
				});
				return new FormArray(arr);
			}
		}
	}

	static builAdvancedBorrowers(borrowers: any, answer: any, question1Step4?, question5Step1?) {
		if (borrowers.length > 0 && answer) {
			let advanceBorrowersFormArr: FormGroup[] = [];
			let advanceBorrowersArr = borrowers.map(r => {
				let bId = r.borrowerId;
				let filtered = answer.filter(a => a.borrowerId === bId)[0];
				filtered.fields[0].answerValue = r.fields[0].answerValue;
				if (question1Step4 && question5Step1 && r.fields[6].answerValue === "בן/ בת זוג") {
					// filtered.fields[1].answerValue = question1Step4.answer.fields[0].answerValue;
					//filtered.fields[1].answerValue = question1Step4.answer.fields[0].answerValue;
					filtered.fields[2].answerValue = question5Step1.answer.fields[0].answerValue;
				}
				return filtered;
			});


			advanceBorrowersArr.forEach(element => {
				console.log(element);
				let zugDisable = element.fields[2].answerValue === "נשוי/ה" ? true : false;

				advanceBorrowersFormArr.push(new FormGroup({
					borrowerFullName: new FormControl({
						value: element.fields[0].answerValue || "",
						disabled: false
					}),
					// borrowerAddress: new FormControl({
					// 	value: element.fields[1].answerValue || "",
					// 	disabled: zugDisable
					// }),
					borrowerChildrenNumber: new FormControl({
						value: element.fields[1].answerValue || "",
						disabled: false
					}),

					borrowerMaritalStatus: new FormControl({ value: element.fields[2].answerValue || "", disabled: true }),

					borrowerId: new FormControl(element.borrowerId || "")
				}))
			});
			console.log("*************************", advanceBorrowersArr)
			return new FormArray(advanceBorrowersFormArr);
		}
	}

	remove(index) {
		this.borrowersArray.removeAt(index);
		this.draft.indexCheckBorrower = this.draft.indexCheckBorrower - 1;
		if (this.draft.listLoansArrayforCreateOpp.length > 1 && this.draft.listCreateCustomerBorrowersArray.length > 1) {
			this.draft.listLoansArrayforCreateOpp.pop();
			this.draft.listCreateCustomerBorrowersArray.pop();
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/borrowers-array/borrowers-array.component.ts